/**************************************************
 * Nombre:       Dialogo_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Soporte from "../Formularios/Formulario_Soporte";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

const Dialogo_Soporte = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Creando solicitud')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        entidad.estado = 'Nuevo'
        nuevoAviso({aviso: 'Imagen subida'})

        let doxConsecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'soporte'})
        entidad.consecutivo = doxConsecutivo.data

        entidad.idUsuario = cData.usuario.id
        entidad.nombre = cData.usuario.nombre
        entidad.correo = cData.usuario.correo
        entidad.celular = cData.usuario.celular
        entidad.pais = cData.usuario.pais


        let dox = await guardarDoc('soportes', entidad)
        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'soporte', actual: entidad.consecutivo})
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Soporte props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Enviar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Soporte